import { normalizeWorkModel } from '../lib/workArrangement';

const styles = {
  onsite: ['ONSITE', '#ff7567', '#ef4160'],
  hybrid: ['HYBRID', '#c5f878', '#19d99b'],
  remote: ['REMOTE', '#fff16b', '#ffab57'],
  unknown: ['OMITTED', '#20dfb2', '#57b5ff'],
};

export default function WorkArrangementBadge({ value, title }) {
  const key = normalizeWorkModel(value);
  const [label, start, end] = styles[key];
  return <span title={title} data-work-arrangement={key}
    className="inline-flex shrink-0 items-center whitespace-nowrap rounded px-1.5 py-0.5 text-[9px] font-bold leading-4"
    style={{ background: `linear-gradient(110deg, ${start}, ${end})`, color: '#101820', border: '1px solid rgba(255,255,255,0.18)' }}>
    {label}
  </span>;
}
